<template>
  <div :style="{ height, width }" id="EchartsGG" ref="docement"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    left1Data: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      echartsData: {
        size: 21,
        list: [
          { dysl: "70", mc: "固定式喷灌", dm: "01", sysl: "300" },
          { dysl: "75", mc: "半固定式喷灌", dm: "02", sysl: "2600" },
          { dysl: "40", mc: "平移式喷灌", dm: "03", sysl: "250" },
          { dysl: "70", mc: "绞盘式喷灌", dm: "04", sysl: "9000" },
          { dysl: "70", mc: "微灌式喷灌", dm: "04", sysl: "3000" },
        ],
      },
    };
  },
  // 固定式喷灌300亩、半固定式喷灌2600亩、平移式喷灌250亩、绞盘式喷灌9000亩、微灌式喷灌3000亩，
  mounted() {
    this.loadEchartsAnimate();
  },
  methods: {
    chartsRelativeSize(percent, derection) {
      var windowW = this.$refs.docement.offsetWidth;
      var windowH = this.$refs.docement.offsetHeight;
      var r = 0;
      if ("h" === derection) {
        r = (percent * windowH) / 100;
      } else {
        r = (percent * windowW) / 100;
      }
      return r;
    },
    loadEchartsAnimate() {
      var that = this;
      var echarts = require("echarts");
      var myCharts = echarts.init(document.getElementById("EchartsGG"));
      var option = {
        color: ["#407FFF", "#00FFBA"],
        tooltip: {
          trigger: "axis",
          textStyle: {
            color: "#000",
            fontSize: "40",
          },
          //   formatter: function (params) {
          //       var arr = [];
          //       params.forEach(function (item) {
          //           var N=item.seriesName;
          //           var V = '';
          //           if(item.value>100000000){//亿
          //               V += (item.value/100000000).toFixed(1) + '亿';
          //           }else if( item.value>10000){//万
          //               V += (item.value/10000).toFixed(1) + '万';
          //           }else{
          //               V += item.value;
          //           }
          //           var a = {name:N,value:V};
          //           arr.push(a);
          //       });
          //       var num = '';
          //       arr.forEach(function (item) {
          //           num += item.name+":"+item.value+"<br/>";
          //       });
          //       return params[0].name +"<br>"+ num;
          //   }
        },
        grid: {
          left: "0%",
          right: "8%",
          bottom: "8%",
          top: "18%",
          containLabel: true,
        },
        title: {
          text: "单位：亩", // 替换为您所需的标题文本
          textStyle: {
            color: "#D6FFFF", // 文本颜色
            fontSize: 30, // 字体大小
            fontWeight: "normal", // 字体粗细
          },
          // left: "right", // 标题水平居中
          top: "5%", // 标题距离顶部的距离，可根据需要调整
          right: "7%",
        },
        // legend: {
        //   orient: "horizontal",
        //   top: "10px",
        //   right: "0",
        //   itemWidth: 26,
        //   itemHeight: 12,
        //   icon: "rect",
        //   textStyle: {
        //     color: "#fff",
        //     fontSize: "12px",
        //     padding: [5, 0, 0, 0],
        //   },
        //   data: ["水变化量", "肥料变化量"],
        //   z: 10001,
        // },
        xAxis: [
          {
            type: "category",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#1F4457", //左边线的颜色
                width: "1", //坐标线的宽度
              },
            },
            axisLabel: {
              textStyle: {
                color: "#fff", //坐标值得具体的颜色,
                fontSize: "30",
                lineHeight:40
              },
              interval: 0,
              formatter: function (params) {
                var str = "";                 // 最终拼接成的字符串
                var paramsLen = params.length;// 获取每项文字的个数
                var len = 3;                  // 每行能显示的字的个数（根据实际情况自己设置）
                var rowNumber = Math.ceil(paramsLen / len); // 换行的话，需要显示几行，向上取整
                if (paramsLen > len) {        //大于设定的len就换行，不大于就不变化
                  for (var i = 0; i < rowNumber; i++) {
                    var temp = "";            // 表示每一次截取的字符串
                    var start = i * len;      // 开始截取的位置
                    var end = start + len;    // 结束截取的位置
                    if (i == rowNumber - 1) { // 最后一次不换行
                      temp = params.substring(start, paramsLen);
                    } else {                  // 每一次拼接字符串并换行
                      temp = params.substring(start, end) + "\n";
                    }
                    str += temp;              // 最终拼成的字符串
                  }
                } else {                      // 给新的字符串赋值
                  str = params;
                }
                return str;                   //返回字符串
              }
            },
            axisTick: false,
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            axisLine: {
              show: false,
              lineStyle: {
                type: "solid",
                color: "#20465A", //左边线的颜色
                width: "2", //坐标线的宽度
              },
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#93B9B8", //坐标值得具体的颜色,
                fontSize: "30",
              },
            },
            axisTick: false,
            splitLine: {
              //坐标轴在grid区域中的分隔线（网格中的横线）
              show: true,
              lineStyle: {
                color: "rgba(255,255,255,.5)",
                width: 1,
                type: "dashed",
              },
            },
          },
        ],
        series: [
          {
            name: "数据",
            type: "bar",
            barGap: 0,
            barWidth: 60,
            data: [],
            label: {
              normal: {
                show: true,
                position: 'top',
                fontSize: 24,
                color:"#DFD504",
              }
            },
            itemStyle: {
              normal: {
                // //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
                // barBorderRadius:[5, 5, 5, 5],
                // borderColor: "#40B9BB",
                //   borderWidth: [0, 0, 2, 0],    // 上方边框宽度为2，其他边框宽度为0// 边框类型为实线
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  { offset: 1, color: "#39CDC6" },
                  { offset: 0, color: "rgba(67,170,165,0)" },
                  { offset: 0.9, color: "rgba(67,170,165,1)" },
                ]),
              },
            },
          },
          // {
          //   name: "肥料变化量",
          //   type: "bar",
          //   barGap: 0,
          //   barWidth: 20,
          //   data: [],
          //   itemStyle: {
          //     normal: {
          //       //这里设置柱形图圆角 [左上角，右上角，右下角，左下角]
          //       // barBorderRadius:[5, 5, 5, 5],
          //       borderColor: "#3CB4B5",
          //       color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [
          //         { offset: 0, color: "#45FFFD" },
          //         { offset: 1, color: "rgba(69,255,253,0)" },
          //       ]),
          //     },
          //   },
          // },
        ],
      };
      for (var i = 0; i < this.echartsData.list.length && i < 5; i++) {
        option.xAxis[0].data.push(that.echartsData.list[i].mc);
        option.series[0].data.push(that.echartsData.list[i].sysl);
        //   option.series[1].data.push(that.echartsData.list[i].dysl);
      }
      myCharts.setOption(option);

      if (window.hbfxInterval) {
        clearInterval(window.hbfxInterval);
      }
      window.hbfxIndex = 0;
      // window.hbfxInterval = setInterval(function () {
      //   option.xAxis[0].data.shift();
      //   option.xAxis[0].data.push(
      //     that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
      //       .mc
      //   );
      //
      //   option.series[0].data.shift();
      //   option.series[0].data.push(
      //     that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
      //       .sysl
      //   );
      //
      //   // option.series[1].data.shift();
      //   // option.series[1].data.push(
      //   //   that.echartsData.list[window.hbfxIndex % that.echartsData.list.length]
      //   //     .dysl
      //   // );
      //
      //   myCharts.setOption(option);
      //   window.hbfxIndex++;
      // }, 2000);
    },
  },
};
</script>
<style lang="less">
.min-body {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #010827;
}
</style>
